import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const SoneiumLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M15.452.495c6.134 1.843 9.739 8.178 8.19 14.392-1.548 6.215-7.708 10.116-13.988 8.858l.023-.023 3.642-3.602.558-.553 2.053-2.037a11.322 11.322 0 0 0 1.811-2.238c1.583-2.573 1.155-5.828-1.038-8.021a6.647 6.647 0 0 0-6.251-1.76ZM.359 9.092C1.905 2.885 8.052-1.014 14.326.232l-.053.051c-.48.475-4.157 4.107-6.222 6.164a11.189 11.189 0 0 0-1.812 2.234 6.45 6.45 0 0 0 1.046 8.033 6.653 6.653 0 0 0 6.252 1.76l-5.012 5.005C2.403 21.626-1.19 15.297.359 9.092Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};